import { createFileRoute, useNavigate, useRouter } from "@tanstack/react-router"
import { CompanyDetailPage } from "@/components/dashboard/buyer/pages/CompanyDetailPage"
import { useFindSupplierStore } from "@/store/find-supplier.store"

export const Route = createFileRoute("/explore/companies/$companyId")({
  validateSearch: (search: Record<string, unknown>): {
    companyType?: "internal" | "external" | "lead"
    companyName?: string
    category?: string
    returnUrl?: string
    searchTerm?: string
  } => ({
    companyType: (search.companyType as "internal" | "external" | "lead") || "internal",
    companyName: (search.companyName as string) || undefined,
    category: (search.category as string) || undefined,
    returnUrl: (search.returnUrl as string) || undefined,
    searchTerm: (search.searchTerm as string) || undefined,
  }),
  component: FindSupplierCompanyDetailRoute,
})

function FindSupplierCompanyDetailRoute() {
  const { companyId } = Route.useParams()
  const { companyType, returnUrl, searchTerm } = Route.useSearch()
  const navigate = useNavigate()
  const router = useRouter()
  const companyFiltersStore = useFindSupplierStore((s) => s.companyFilters)

  const handleBack = () => {
    if (returnUrl) {
      router.history.push(returnUrl)
      return
    }
    if (searchTerm) {
      const filters = Object.keys(companyFiltersStore || {}).length > 0
        ? JSON.stringify(companyFiltersStore)
        : undefined
      navigate({
        to: "/explore/suppliers",
        search: {
          searchTerm,
          companyFilters: filters,
        },
      })
    } else {
      navigate({ to: "/explore" as any })
    }
  }

  return (
    <CompanyDetailPage
      companyId={companyId}
      companyType={companyType || "internal"}
      onBack={handleBack}
    />
  )
}